import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

const Manifesto = () => {
  const { t } = useLang();

  return (
    <section
      data-testid="manifesto-section"
      className="py-20 md:py-32 relative overflow-hidden"
    >
      <div className="container-hk">
        <div className="max-w-2xl mb-16 md:mb-24">
          <div className="text-[10px] md:text-xs tracking-[0.35em] text-[var(--hk-red)] font-bold mb-3">
            // 002 · {t.manifesto.overline}
          </div>
          <h2 className="font-display text-4xl md:text-6xl lg:text-7xl uppercase leading-[0.95] tracking-tight">
            {t.manifesto.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
          {t.manifesto.chapters.map((c, i) => (
            <motion.article
              key={c.n}
              data-testid={`manifesto-chapter-${c.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.08, duration: 0.7, ease: [0.19, 1, 0.22, 1] }}
              className={`relative border-t border-white/15 pt-8 md:pt-10 ${
                i === 0 ? "lg:col-span-6" : ""
              } ${i === 1 ? "lg:col-span-6" : ""} ${
                i === 2 ? "lg:col-span-4" : ""
              } ${i === 3 ? "lg:col-span-4" : ""} ${
                i === 4 ? "lg:col-span-4" : ""
              }`}
            >
              <div
                aria-hidden
                className="font-display absolute -top-6 md:-top-10 right-0 text-6xl md:text-8xl lg:text-9xl leading-none text-transparent"
                style={{ WebkitTextStroke: "1px rgba(255,255,255,0.12)" }}
              >
                {c.n}
              </div>
              <div className="font-mono text-xs tracking-[0.3em] text-[var(--hk-red)] mb-4">
                CH. {c.n}
              </div>
              <h3 className="font-display text-xl md:text-2xl uppercase tracking-tight mb-4">
                {c.title}
              </h3>
              <p className="text-sm md:text-[15px] text-white/65 leading-relaxed max-w-lg">
                {c.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
